import React, { useState, useEffect, useContext } from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter, Routes, Route, useLocation, useNavigate } from 'react-router-dom';
import PvtRoute from './Helpers/PvtRoute';
import { routes } from './Helpers/Routes';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import Sidebar from './Components/SideBar/SideBar';
import "./index.css";
import TopBar from './Components/TopBar/TopBar';
import { UserInfo } from "./Context/userInfo";
import { Chat } from "./Context/showChat";
import { ChatProvider } from './Context/showChat';
import { UserProvider } from './Context/userInfo';
import Axios from "../src/Helpers/Interceptors";
import SidebarDepartment from './Components/SidebarDepartment/SidebarDepartment';
import TopBarDepartment from './Components/TopBarDepartment/TopBarDepartment';
import Loader from '../src/Components/Loader/Loader';
import Chatbot from './Components/ChatBot/ChatBot';

import { getRole } from '../src/Helpers/utils';

const App = () => {
  const navigate = useNavigate();
  const [loadingUser, setLoadingUser] = useState(true);
  const { chats, updateChat } = useContext(Chat);
  const { userData, updateUserData } = useContext(UserInfo);
  const [roles, setRoles] = useState(null);

  useEffect(() => {
    const token = localStorage.getItem("token");
    if (token && !userData) {
      // Fetch user data from API only if not already available
      fetchUserData(token);
    }else{

      setTimeout((Res)=>{
        setLoadingUser(false);
      },4000)
     // Set loadingUser to false once user data is available
    }
  }, [userData]); // Depend on `userData` so that we fetch only if it isn't set

  useEffect(() => {
    if (userData) {
      setRoles(getRole(userData.data?.userInfo?.roles));
      setTimeout((Res)=>{
        setLoadingUser(false);
      },4000)// Set loadingUser to false once user data is available
    }
  }, [userData]); // This effect will run after `userData` is updated

  const fetchUserData = async (token) => {
    try {
      setLoadingUser(true); // Start loading when making the request
      const response = await Axios.get('user/user-details');
      if (response.status === 200) {
        updateUserData(response.data); // Update context with fetched data
      }
    } catch (error) {
      console.error(error); // Handle error here (maybe show error toast)
    } finally {
      setTimeout((Res)=>{
        setLoadingUser(false);
      },4000) // End loading when the request is done
    }
  };

  const location = useLocation();
  const [isSidebarOpen, setIsSidebarOpen] = useState(true);
  const toggleSidebar = () => setIsSidebarOpen(!isSidebarOpen);

  const showSidebarAndTopbar = ![
    '/', '/register', '/forgot-password'
  ].includes(location.pathname) && !location.pathname.startsWith('/reset-password');




  const logout = () => {
    localStorage.removeItem('loginTime')
    localStorage.removeItem('userData')
    localStorage.removeItem('token')
    updateUserData(null)
    setRoles(null)
    navigate('/')
  }
  const logout1 = () => {
    localStorage.removeItem('loginTime')
    localStorage.removeItem('userData')
    localStorage.removeItem('token')
    updateUserData(null)
    setRoles(null)
    navigate('/')
  }

  return (
    <div className={`app ${isSidebarOpen ? 'sidebar-open' : ''}`} style={{ height: '100vh' }}>
      {loadingUser && <Loader />} {/* Show loader if still loading */}

      {!loadingUser && (
        <>
          {/* Conditional rendering for Sidebar and TopBar based on role */}
          {showSidebarAndTopbar && roles === 'DEPARTMENT' && (
            <>
              <SidebarDepartment isOpen={isSidebarOpen} toggleSidebar={toggleSidebar} />
              <TopBarDepartment toggleSidebar={toggleSidebar} logout={logout}/>
            </>
          )}

          {showSidebarAndTopbar && roles !== 'DEPARTMENT' && (
            <>
              <Sidebar isOpen={isSidebarOpen} toggleSidebar={toggleSidebar} />
              <TopBar toggleSidebar={toggleSidebar}  logout1={logout1}/>
            </>
          )}

          <div
            className={showSidebarAndTopbar
              ? roles === 'DEPARTMENT'
                ? 'home-section1-department'
                : 'home-section1'
              : ''
            }
            style={{ height: 'auto' }}
          >
            <ToastContainer />
            <Routes>
              {routes()?.map((val, i) => (
                <Route
                  key={i}
                  path={val.path}
                  element={
                    <PvtRoute
                      children={val}
                      path={val.path?.split("/")[1]}
                    />
                  }
                />
              ))}
            </Routes>
          </div>

          {showSidebarAndTopbar && roles !== 'DEPARTMENT' && chats && <Chatbot />}
        </>
      )}
    </div>
  );
};

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <BrowserRouter>
    <ChatProvider>
      <UserProvider>
        <App />
      </UserProvider>
    </ChatProvider>
  </BrowserRouter>
);
